import { type DocumentTableRow } from 'features/knowledgeDocumentViewer'
import { PAGE_SIZE } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/constants'
import { useCallback, useMemo } from 'react'

interface UseDocumentCardPaginationParams {
  filteredDocuments: DocumentTableRow[]
  totalCount: number
  filteredCount: number
  hasActiveFilters: boolean
  activeIndex: number
  onActiveIndexChange: (index: number) => void
}

export interface DocumentCardPagination {
  currentPage: number
  displayCount: number
  pageDocuments: DocumentTableRow[]
  pageActiveIndex: number
  pageEnd: number
  pageStart: number
  totalPages: number
  handlePageChange: (page: number) => void
}

export function useDocumentCardPagination({
  filteredDocuments,
  totalCount,
  filteredCount,
  hasActiveFilters,
  activeIndex,
  onActiveIndexChange,
}: UseDocumentCardPaginationParams): DocumentCardPagination {
  const displayCount = hasActiveFilters ? filteredCount : totalCount
  const currentPage = Math.floor(activeIndex / PAGE_SIZE)
  const pageStart = currentPage * PAGE_SIZE
  const pageEnd = Math.min(pageStart + PAGE_SIZE, filteredDocuments.length)
  const pageDocuments = useMemo(
    () => filteredDocuments.slice(pageStart, pageEnd),
    [filteredDocuments, pageStart, pageEnd]
  )
  const totalPages = Math.ceil(filteredDocuments.length / PAGE_SIZE)
  const pageActiveIndex = activeIndex - pageStart

  const handlePageChange = useCallback(
    (page: number) => {
      onActiveIndexChange(page * PAGE_SIZE)
    },
    [onActiveIndexChange]
  )

  return {
    currentPage,
    displayCount,
    pageDocuments,
    pageActiveIndex,
    pageEnd,
    pageStart,
    totalPages,
    handlePageChange,
  }
}
